<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent width="1200px">
      <v-form
        class="matching"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-shuffle</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addMatching'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  dark
                  :disabled="loading"
                  @click="closeDialogQuestion"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <quill-editor
                  class="editor bg-editor"
                  ref="question"
                  v-model="question"
                />
              </v-col>
              <!-- <v-col :lg="4" :md="4" :sm="12" class="px-10">
                      <p class="title">
                        คะแนนรวม
                        <span class="red--text">*</span>
                      </p>
                      <v-text-field
                        type="number"
                        rounded
                        outlined
                        :rules="scoreRules"
                        clearable
                        class="textField"
                        placeholder="คะแนน"
                        v-model="question_score"
                        min="0"
                        @change="checkMinScore"
                      ></v-text-field>
              </v-col>-->
            </v-row>
            <v-row>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addVoiceOpt'
                      )
                    }}
                  </p>
                </div>
                <!-- <div class="upload-btn-wrapper">
                  <button class="btn-choose body-1 font-weight-medium">
                    <v-icon>mdi-upload</v-icon>Upload audio
                  </button>
                  <input
                    type="file"
                    name="myfile"
                    @change="preview"
                    accept="image/png, image/jpeg, image/bmp"
                  />
                </div>-->

                <v-card height="100" outlined v-if="audio_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('audio')"
                    >
                      <v-icon left>mdi-volume-high</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addVoice'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" v-if="audio_id" outlined>
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="audio_id"
                        @click="deletemedia('audio')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <vuetify-audio
                        :file="audio_url"
                        :audioPlaying.sync="audioPlaying"
                      ></vuetify-audio>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="6">
                <div class="d-flex mb-2">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addVdoOpt'
                      )
                    }}
                  </p>
                </div>
                <v-card height="100" outlined v-if="video_id === null">
                  <div class="text-center center-panel">
                    <v-btn
                      outlined
                      color="blue-grey"
                      @click="openMediaDialog('video')"
                    >
                      <v-icon left>mdi-video</v-icon
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addVdo'
                        )
                      }}
                    </v-btn>
                  </div>
                </v-card>
                <v-card height="85%" outlined v-if="video_id">
                  <v-row>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        class="mb-0 body-2 error--text text-capitalize"
                        color="white"
                        v-if="video_id"
                        @click="deletemedia('video')"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.delete'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-5">
                      <div class="videoPlayer ma-auto pb-3">
                        <video-player
                          class="video-player-box videoContainer"
                          ref="videoPlayer"
                          :options="playerOptions"
                          :playsinline="true"
                          customEventName="customstatechangedeventname"
                          @ready="playerReadied"
                        ></video-player>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="6">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      "$vuetify.courseManagement.lectureStep.insertExam.insertMatching.randomType"
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-radio-group v-model="setRandomChoice" mandatory row>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.noRandom'
                      )
                    "
                    :value="false"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.random'
                      )
                    "
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12">
                <!-- <p class="subtitle-1">how to choose the correct answer to answer by clicked on the space on the left of the choices.</p> -->
                <!-- <p class="subtitle-1">
                  <span>
                    <v-icon left color="blue">mdi-information-outline</v-icon>
                  </span>พิมพ์ตัวเลือกตั้งต้นในกล่องข้อความเพื่อเพิ่มตัวเลือกตั้งต้น
                </p>-->
                <!-- <v-alert text type="info" border="left">
                  <strong class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg1'
                    )
                  }}</strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg2'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg3'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg4'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg5'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  <br />
                  <strong class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg6'
                    )
                  }}</strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg7'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg8'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg9'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg10'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg11'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg12'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  <br />{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg13'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg14'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg15'
                    )
                  }}
                  <br />
                  <strong class="font-weight-bold">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg16'
                    )
                  }}</strong>
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg17'
                    )
                  }}
                  <strong class="font-weight-bold">
                    <label class="headExplan">"</label
                    >{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg18'
                      )
                    }}
                    <label class="headExplan">"</label>
                  </strong>
                </v-alert> -->
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.ansOption'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <p
                  class="subtitle-1 mb-0"
                  v-if="questionMatch.length == 0 || answer.length == 0"
                >
                  ยังไม่มีรายการตัวเลือกคำตอบ กรุณาเพิ่มตัวเลือกคำตอบด้านล่าง
                </p>
                <p
                  class="subtitle-1 mb-0"
                  v-if="questionMatch.length && answer.length"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.info4'
                    )
                  }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pb-0">
                <v-row>
                  <v-card
                    class="px-5 pt-5 pb-0 ml-0 mr-2"
                    elevation="0"
                    color="grey lighten-5"
                    width="100%"
                  >
                    <p class="title mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg3'
                        )
                      }}
                    </p>
                  </v-card>
                </v-row>

                <v-row
                  v-for="(choice, choiceIndex) in questionMatch"
                  :data="choice"
                  :key="choiceIndex"
                >
                  <v-card
                    class="pa-5 ml-0 mr-2"
                    elevation="0"
                    color="grey lighten-5"
                    width="100%"
                  >
                    <v-card outlined>
                      <v-card-text class="pb-0">
                        <v-row class="mx-0">
                          <div class="subtitle-1">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.choiceASide'
                              ) +
                              (choiceIndex + 1) +
                              ' '
                            }}
                            {{
                              '(' +
                              (choice.score ? choice.score : '') +
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.scoreChoice'
                              ) +
                              ')'
                            }}
                          </div>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="choice.boolean == false"
                            :disabled="bools == true"
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            @click="editOption(choice)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.edit'
                                )
                              }}
                            </p>
                          </v-btn>
                          <v-divider
                            v-if="choice.boolean == false"
                            inset
                            vertical
                            class="mb-2 mx-1"
                          ></v-divider>
                          <v-btn
                            v-if="choice.boolean == false"
                            :disabled="
                              questionMatch.length <= 1 || bools == true
                            "
                            elevation="0"
                            class="mb-0 body-2 error--text text-capitalize"
                            color="white"
                            @click="openRemoveChoiceDialog(choice)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.delete'
                                )
                              }}
                            </p>
                          </v-btn>
                          <v-btn
                            v-if="choice.boolean == true"
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            :disabled="
                              !choice.text ||
                              choice.score == null ||
                              choice.score == 0
                            "
                            @click="validate(choice, null)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.save'
                                )
                              }}
                            </p>
                          </v-btn>
                          <v-divider
                            v-if="choice.boolean == true"
                            inset
                            vertical
                            class="mb-2 mx-1"
                          ></v-divider>
                          <v-btn
                            v-if="choice.boolean == true"
                            elevation="0"
                            class="mb-0 body-2 text-capitalize"
                            color="white"
                            @click="canCelEditOption(choice)"
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                                )
                              }}
                            </p>
                          </v-btn>
                        </v-row>
                      </v-card-text>
                      <v-card-title
                        v-if="choice.boolean == false"
                        class="py-0"
                        v-html="choice.text"
                      ></v-card-title>
                      <quill-editor
                        v-if="choice.boolean == true"
                        v-model="choice.text"
                        class="editor pa-3"
                        ref="description"
                      />
                      <v-row class="pa-3" v-if="choice.boolean == true">
                        <v-col cols="5">
                          <p>
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.score'
                              )
                            }}
                            <span class="red--text">*</span>
                          </p>
                          <v-text-field
                            type="number"
                            outlined
                            :rules="scoreRules"
                            clearable
                            required
                            :placeholder="
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.score'
                              )
                            "
                            v-model.number="choice.score"
                            min="0"
                            @change="checkMinScore(choiceIndex)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-divider class="mx-4"></v-divider>
                      <v-card-text>
                        <v-row class="mx-0">
                          <div class="subtitle-1">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.matchingWith'
                              )
                            }}
                            :
                            <v-chip
                              label
                              class="ma-2"
                              :close="choice.hover > 0"
                              @click:close="
                                removeItemFromChoice(choiceIndex, matchIndex)
                              "
                              v-for="(match, matchIndex) in choice.matches"
                              :key="matchIndex"
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.choiceMatching'
                                )
                              }}
                              {{ match + 1 }}</v-chip
                            >
                            <span
                              v-if="
                                choice.matches.length == 0 && choice.hover > 0
                              "
                              class="font-weight-light"
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.info3'
                                )
                              }}</span
                            >
                            <v-btn
                              small
                              :disabled="
                                choice.boolean == true || answer.length == 0
                              "
                              :class="
                                choice.hover == 0
                                  ? 'ml-3 mb-0 body-2 text-primary text-capitalize'
                                  : 'ml-3 button-primary'
                              "
                              :outlined="choice.hover == 0"
                              outline
                              @click="
                                choice.hover == 0
                                  ? choiceOnClick(choiceIndex)
                                  : done()
                              "
                            >
                              <v-icon left v-if="choice.hover == 0"
                                >mdi-plus</v-icon
                              >
                              <span v-if="choice.hover == 0">{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.match'
                                )
                              }}</span>

                              <v-icon left v-if="choice.hover > 0"
                                >mdi-check</v-icon
                              >
                              <span v-if="choice.hover > 0">{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.done'
                                )
                              }}</span>
                            </v-btn>
                          </div>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <!-- <v-col :lg="12" :md="12" :sm="12">
                      <v-btn
                        v-if="editingChoiceIndex == null"
                        icon
                        @click="openRemoveChoiceDialog(choiceIndex)"
                        style="float: right"
                      >
                        <v-icon large>mdi-close</v-icon>
                      </v-btn>
                      <p class="title my-0 font-weight-bold">ตัวเลือกตั้งต้นที่ {{choiceIndex+1}}</p>
                    </v-col>

                    <v-row class="ml-3 d-flex align-center">
                      <span class="font-weight-light title">จับคู่กับ :</span>
                      <v-col>
                        <v-chip
                          class="ma-2"
                          :close="choice.hover > 0"
                          color="teal"
                          text-color="white"
                          @click:close="removeItemFromChoice(choiceIndex, matchIndex)"
                          v-for="(match, matchIndex) in choice.matches"
                          :key="matchIndex"
                        >ตัวเลือกที่ {{ (match + 1) }}</v-chip>
                        <span
                          v-if="choice.matches.length == 0 && choice.hover > 0"
                          class="ml-3 mr-3 title font-weight-bold"
                        >กดเลือกจับคู่ที่ฝั่งตัวเลือก</span>
                        <v-btn
                          color="primary"
                          class="ml-3 pl-7 pr-7 title"
                          :outlined="choice.hover == 0"
                          rounded
                          outline
                          @click="choice.hover == 0 ? choiceOnClick(choiceIndex) : done()"
                        >
                          <span class="ml-3 mr-3" v-if="choice.hover > 0">เสร็จสิ้น</span>
                          <span class="ml-3 mr-3" v-if="choice.hover == 0">จับคู่ตัวเลือก</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-col>
                      <quill-editor
                        v-model="choice.text"
                        class="editor editor-style"
                        ref="description"
                        :value="description"
                        :options="editorOption"
                      />
                    </v-col>
                    <v-row class="d-flex align-center mb-0 mr-1 float-right">
                      <v-col>
                        <p class="title">
                          คะแนน
                          <span class="red--text">*</span>
                        </p>
                        <v-text-field
                          type="number"
                          rounded
                          outlined
                          :rules="scoreRules"
                          clearable
                          required
                          placeholder="กรุณาระบุคะแนน"
                          v-model="choice.score"
                          min="0"
                          @change="checkMinScore(choiceIndex)"
                        ></v-text-field>
                      </v-col>
                    </v-row>-->
                  </v-card>
                </v-row>
                <!-- <v-row class="justify-center ma-3">
                  <v-btn
                    :disabled="bools == true"
                    elevation="0"
                    class="pl-5 pr-5 mb-0 body-2 text-primary text-capitalize"
                    color="white"
                    @click="addChoice"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addChoiceASide'
                      )
                    }}
                  </v-btn>
                </v-row> -->
                <v-row>
                  <v-card
                    class="pa-5 ml-0 mr-2"
                    elevation="0"
                    color="grey lighten-5"
                  >
                    <p class="subtitle-1">
                      <span>
                        <v-icon left color="blue"
                          >mdi-information-outline</v-icon
                        > </span
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.info1'
                        )
                      }}
                    </p>
                    <quill-editor
                      class="editor bg-editor pa-3"
                      v-model="addAnswer"
                      ref="answers"
                    />
                    <v-row class="d-flex" align="center">
                      <v-col cols="2">
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.score'
                            )
                          }}
                          <span class="red--text">*</span>
                        </p>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          type="number"
                          outlined
                          clearable
                          required
                          hide-details
                          :placeholder="
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.score'
                            )
                          "
                          v-model="choiceScore"
                          min="0"
                          @change="checkMinScore(choiceIndex)"
                        ></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>

                      <v-col cols="4" class="text-right pl-0 mt-5 mb-5">
                        <v-btn
                          :disabled="choiceScore == null || addAnswer == ''"
                          elevation="0"
                          class="subtitle-2 text-capitalize font-weight-light button-primary"
                          @click="addChoice"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addChoiceASide'
                            )
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <!-- <v-row class="d-flex align-center justify-center">
                  <v-btn class="title" color="primary" dark x-large rounded @click="addChoice">
                    <v-icon left>mdi-plus</v-icon>เพิ่มตัวเลือกตั้งต้น
                  </v-btn>
                </v-row>-->
              </v-col>
              <!-- <v-col align="center">
                      <v-divider vertical></v-divider>
              </v-col>-->
              <v-col cols="6" class="pb-0">
                <v-row>
                  <v-card
                    class="px-5 pt-5 pb-0 ml-2 mr-0"
                    elevation="0"
                    color="grey lighten-5"
                    width="100%"
                    height="100%"
                  >
                    <p class="title mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.msg10'
                        )
                      }}
                    </p>
                  </v-card>
                </v-row>

                <v-row
                  v-for="(item, itemIndex) in answer"
                  :data="item"
                  :key="itemIndex"
                >
                  <v-card
                    class="pa-5 ml-2 mr-0 pb-0"
                    elevation="0"
                    color="grey lighten-5"
                    width="100%"
                  >
                    <v-row class="ma-0 pa-0">
                      <v-col
                        cols="1"
                        class="ma-0 pa-0"
                        @click="itemOnClick(itemIndex)"
                        v-if="editingChoiceIndex != null"
                      >
                        <v-card-title class="px-0 pt-4">
                          <v-checkbox
                            :input-value="item.hover > 0 ? true : false"
                            value
                            class="title my-0 font-weight-bold"
                          ></v-checkbox>
                        </v-card-title>
                      </v-col>
                      <v-col
                        :cols="editingChoiceIndex != null ? '11' : '12'"
                        class="ma-0 pa-0"
                      >
                        <v-card outlined>
                          <v-card-text class="pb-0">
                            <v-row class="mx-0">
                              <div class="subtitle-1">
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.choiceBSide'
                                  ) +
                                  (itemIndex + 1) +
                                  ' '
                                }}
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn
                                v-if="item.boolean == false"
                                :disabled="boolsAnswer == true"
                                elevation="0"
                                class="mb-0 body-2 text-primary text-capitalize"
                                color="white"
                                @click="editOptionAnswer(item)"
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.edit'
                                    )
                                  }}
                                </p>
                              </v-btn>
                              <v-divider
                                v-if="item.boolean == false"
                                inset
                                vertical
                                class="mb-2 mx-1"
                              ></v-divider>
                              <v-btn
                                v-if="item.boolean == false"
                                :disabled="answer.length <= 1 || bools == true"
                                elevation="0"
                                class="mb-0 body-2 error--text text-capitalize"
                                color="white"
                                @click="openRemoveItemDialog(item)"
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.delete'
                                    )
                                  }}
                                </p>
                              </v-btn>
                              <v-btn
                                v-if="item.boolean == true"
                                elevation="0"
                                class="mb-0 body-2 text-primary text-capitalize"
                                color="white"
                                :disabled="!item.text"
                                @click="validate(item, true)"
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.save'
                                    )
                                  }}
                                </p>
                              </v-btn>
                              <v-divider
                                v-if="item.boolean == true"
                                inset
                                vertical
                                class="mb-2 mx-1"
                              ></v-divider>
                              <v-btn
                                v-if="item.boolean == true"
                                elevation="0"
                                class="mb-0 body-2 text-capitalize"
                                color="white"
                                @click="canCelEditOptionAnswer(item)"
                              >
                                <p class="mb-0">
                                  {{
                                    $vuetify.lang.t(
                                      '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                                    )
                                  }}
                                </p>
                              </v-btn>
                            </v-row>
                          </v-card-text>
                          <v-card-title
                            v-if="item.boolean == false"
                            class="py-0"
                            v-html="item.text"
                          ></v-card-title>
                          <quill-editor
                            v-if="item.boolean == true"
                            class="editor pa-3"
                            ref="description"
                            v-model="item.text"
                          />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>

                  <!-- <v-card class="pa-5 mx-4" elevation="0" color="grey lighten-5">
                    <v-col
                      :lg="12"
                      :md="12"
                      :sm="12"
                      class="pt-0 pb-0"
                      @click="itemOnClick(itemIndex)"
                      >
                      <v-btn
                        v-if="editingChoiceIndex == null"
                        icon
                        @click="openRemoveItemDialog(itemIndex)"
                        style="float: right"
                      >
                        <v-icon large>mdi-close</v-icon>
                      </v-btn>
                      <v-checkbox
                        :input-value="item.hover > 0 ? true : false"
                        value
                        :disabled="editingChoiceIndex == null"
                        class="title my-0 font-weight-bold"
                        :label="`ตัวเลือกที่ ${itemIndex + 1}`"
                      ></v-checkbox>
                    </v-col>
                    <v-col :lg="12" :md="12" :sm="12">
                      <quill-editor
                        class="editor editor-style"
                        ref="description"
                        v-model="item.text"
                        :value="description"
                        :options="editorOption"
                      />
                    </v-col>
                  </v-card>-->
                </v-row>
                <!-- <v-row class="justify-center ma-3">
                  <v-btn
                    :disabled="boolsAnswer == true"
                    elevation="0"
                    class="pl-5 pr-5 mb-0 body-2 text-primary text-capitalize"
                    color="white"
                    @click="addItem"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addChoiceBSide'
                      )
                    }}
                  </v-btn>
                </v-row> -->
                <v-row>
                  <v-card
                    class="pa-5 ml-2 mr-0"
                    elevation="0"
                    color="grey lighten-5"
                    height="100%"
                  >
                    <p class="subtitle-1">
                      <span>
                        <v-icon left color="blue"
                          >mdi-information-outline</v-icon
                        > </span
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.info2'
                        )
                      }}
                    </p>
                    <quill-editor
                      class="editor bg-editor pa-3"
                      v-model="addAnswerChoice"
                      ref="answers"
                    />
                    <v-row>
                      <v-col class="text-right pl-0 mt-3 mb-3">
                        <v-btn
                          :disabled="addAnswerChoice == ''"
                          elevation="0"
                          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                          @click="addItem"
                          >{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.addChoiceBSide'
                            )
                          }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <!-- <v-row class="d-flex align-center justify-center">
                  <v-btn class="title" color="primary" dark x-large rounded @click="addItem">
                    <v-icon left>mdi-plus</v-icon>เพิ่มตัวเลือก
                  </v-btn>
                </v-row>-->
              </v-col>
            </v-row>
            <v-row>
              <v-card class="pa-5 mt-6" elevation="0" color="grey lighten-5">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.answerDescription'
                    )
                  }}
                </p>
                <p class="subtitle-1">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertSingle.choiceMsg2'
                    )
                  }}
                </p>
                <quill-editor
                  class="editor bg-editor"
                  v-model="answer_description"
                  :rules="answerDescriptionRules"
                  ref="answer_description"
                />
              </v-card>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              :disabled="loading"
              @click="closeDialogQuestion"
              >{{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="validate(null, null)"
              :disabled="!validationForm() || loading || matchingBool == true"
              :loading="loading"
              >{{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
      <insert-media-dialog
        :isMediaOpen.sync="mediaDialog"
        :isMediaClose="closeMediaDialog"
        :on-set-video="setVideo"
        :on-set-audio="setAudio"
        :typeMedia.sync="mediaType"
      ></insert-media-dialog>
    </v-dialog>
    <v-dialog v-model="dialogRemoveChoice" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.confirmDeleteChoice'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.confirmDeleteChoiceDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            outlined
            @click="dialogRemoveChoice = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.cancel'
              )
            }}</v-btn
          >
          <v-btn color="error darken-1" dark @click="removeChoice">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirm'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRemoveItem" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.confirmDeleteChoice'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.confirmDeleteChoiceDetail'
          )
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            dark
            outlined
            @click="dialogRemoveItem = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.cancel'
              )
            }}</v-btn
          >
          <v-btn color="error darken-1" dark @click="removeItem">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.confirm'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnningToSaveDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmCloseDialog()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import {
  insertChoice,
  updateChoice,
  insertQuestion,
  getQuestionById,
  updateQuestion,
} from '@/service/course/exam';

import insertMediaDialog from '@/views/course/dialog/insertMediaDialog.vue';
import { serverName } from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';

import videojs from 'video.js';
window.videojs = videojs;
import $ from 'jquery';
import { getPrivateFile } from '@/service/upload/upload.js';

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    randomChoice: {
      type: Boolean,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    questions: {
      type: String,
    },
    articleId: {
      type: String,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reorderLecture: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
  },
  components: {
    insertMediaDialog,
    // VuetifyAudio: () => import("vuetify-audio"),
    VuetifyAudio: () => import('@/components/vuetify-audio'),
    videoPlayer,
  },
  data() {
    return {
      setRandomChoice: false,
      valid: true,
      notifications: false,
      sound: true,
      widgets: false,
      question: '',
      question_score: '',
      answer_description: '',
      // nameRules: [v => !!v || "กรุณากรอกคะแนน"],
      rows: [1],
      chars: [],
      questionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.questionRules'
          ),
      ],
      answerDescriptionRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.answerDescriptionRules'
          ),
      ],
      scoreRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.scoreRules1'
          ),
        (v) =>
          v > 0 ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertMatching.scoreRules2'
          ),
      ],
      // percentRules: [
      //   v => !!v || "Percent is required",
      //   v => (v && v <= 99) || "Percent must not be more than 100"
      // ],
      // answerRules: [v => !!v || "Answer is required"],

      dialog: false,
      description: '',
      editingChoiceIndex: null,
      questionMatch: [],
      answer: [],
      // audio
      audio_url: '',

      // mediaDialog
      mediaDialog: false,
      audio_id: null,
      video_id: null,

      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        hls: true,
        // width: '300',
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
        // poster: "/static/images/author.jpg"
      },
      successUpload: false,
      isCheckComplete: false,
      urlVideo:
        // "https://fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      cantGetLink: false,
      showUploadPercent: false,
      mediaType: '',
      audioPlaying: false,
      dialogRemoveChoice: false,
      dialogRemoveItem: false,
      removeChoiceIndex: null,
      removeItemIndex: null,
      addAnswer: '',
      choiceScore: null,
      addAnswerChoice: '',
      editChoice: false,
      editChoiceAnswer: false,
      tempChoice: '',
      tempChoiceAnswer: '',
      dialogSuccess: false,
      dialogSaveFail: false,
      bools: false,
      boolsAnswer: false,
      arrChoiceId: [],
      itemChoice: [],
      itemAnswer: [],
      loading: false,
      matchingBool: false,
      warnningToSaveDialog: false,
    };
  },
  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.questionId) {
          let result = await getQuestionById({ id: this.questionId });
          this.oldQuestion = result;
          this.question = result.question;
          this.answer_description = result.note;
          this.setRandomChoice = result.randomChoice;
          let answerChoice = [];
          result.choices.forEach((choice, i) => {
            answerChoice.push({
              ...choice,
              index: i,
              hover: 0,
              boolean: false,
            });
          });
          this.answer = answerChoice;

          let arrCorrectMatch = result.correctMatch;
          let arrQMatch = result.questionMatch;
          let arrScore = result.arrayScore;
          let questionChoice = [];
          result.questionMatch.forEach((question, i) => {
            let match = [];

            arrCorrectMatch[i].correct.forEach((id) => {
              answerChoice.forEach((choice) => {
                if (id._id == choice._id) {
                  match.push(choice.index);
                }
              });
            });

            questionChoice.push({
              text: arrQMatch[i],
              matches: match,
              score: arrScore[i],
              hover: 0,
              boolean: false,
            });
          });
          this.questionMatch = questionChoice;
          // this.question_score = result.score;
          this.audio_id = result.audio;
          this.video_id = result.video;

          this.audio_id ? this.getAudioPreview() : '';
          this.video_id ? this.getPreview('video') : '';
        } else {
          this.valid = false;
          this.dialog_1 = false;
          this.question = '';
          this.question_score = '';
          this.answer_description = '';
          this.setRandomChoice = false;
          this.addAnswer = '';
          this.addAnswerChoice = '';
          this.choiceScore = null;
          this.questionMatch = [];
          this.answer = [];
          this.oldQuestion = {};
          this.audio_id = null;
          this.video_id = null;
          this.editChoice = false;
          this.editChoiceAnswer = false;
          this.bools = false;
          this.boolsAnswer = false;
          this.$refs.form.resetValidation();

          // this.$refs.form.reset();
        }
      } else {
        try {
          // $(".videoPlayer")[0].player.pause();
          $('video').each(function () {
            $(this).get(0).pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.audio_url = '';
          this.audioPlaying = false;
          // $('#player')[0].pause();
          // $('#player')[0].currentTime = 0;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  methods: {
    openRemoveChoiceDialog(item) {
      let index = this.questionMatch.indexOf(item);
      this.itemChoice = item;
      this.dialogRemoveChoice = true;
      if (this.questionMatch.length > 1) {
        this.removeChoiceIndex = index;
      }
    },
    openRemoveItemDialog(item) {
      let index = this.answer.indexOf(item);
      this.itemAnswer = item;
      this.dialogRemoveItem = true;
      if (this.answer.length > 1) {
        this.removeItemIndex = index;
      }
    },
    removeChoice() {
      if (this.questionMatch.length > 1) {
        this.questionMatch.splice(this.removeChoiceIndex, 1);
      }
      this.validate(this.itemChoice, null);
      this.dialogRemoveChoice = false;
    },
    removeItem() {
      if (this.answer.length > 1) {
        this.answer.splice(this.removeItemIndex, 1);
        //remove item from answer
        if (this.removeItemIndex < this.answer.length) {
          for (var j = this.removeItemIndex; j < this.answer.length; j++) {
            this.answer[j].index = j;
          }
        }

        //remove item from every questionMatch contained the certain deleted item
        for (var k = 0; k < this.questionMatch.length; k++) {
          for (var i = 0; i < this.questionMatch[k].matches.length; i++) {
            if (this.questionMatch[k].matches[i] == this.removeItemIndex) {
              this.questionMatch[k].matches.splice(i, 1);
            }
            if (this.questionMatch[k].matches[i] > this.removeItemIndex) {
              this.questionMatch[k].matches[i] -= 1;
            }
          }
        }
      }
      this.validate(this.itemAnswer, null);
      this.dialogRemoveItem = false;
    },
    removeItemFromChoice(choiceIndex, itemIndex) {
      let tmpItem = this.questionMatch[choiceIndex].matches[itemIndex];
      this.editingChoiceIndex = choiceIndex;
      this.questionMatch[choiceIndex].matches.splice(itemIndex, 1);

      for (var i = 0; i < this.answer.length; i++) {
        if (this.answer[i].index == tmpItem) {
          this.answer[i].hover = 0;
        }
      }
    },
    addItemToChoice(choiceIndex, itemIndex) {
      this.questionMatch[choiceIndex].matches.push(
        this.answer[itemIndex].index
      );
      this.answer[itemIndex].hover = 5;
    },
    choiceOnClick(index) {
      this.matchingBool = true;
      if (this.questionMatch[index].hover == 0) {
        this.clearChoicesHover();
        this.clearItemsHover();
        this.editingChoiceIndex = index;
        this.questionMatch[index].hover = 5;
        let selectedChoice = this.questionMatch[index].matches;
        for (var i = 0; i < selectedChoice.length; i++) {
          for (var j = 0; j < this.answer.length; j++) {
            if (selectedChoice[i] == this.answer[j].index) {
              this.answer[j].hover = 5;
            }
          }
        }
      }
    },

    done() {
      this.editingChoiceIndex = null;
      this.matchingBool = false;
      this.clearChoicesHover();
      this.clearItemsHover();
    },
    itemOnClick(itemIndex) {
      if (this.editingChoiceIndex != null) {
        if (this.answer[itemIndex].hover == 0) {
          this.addItemToChoice(this.editingChoiceIndex, itemIndex);
        } else {
          for (
            var i = 0;
            i < this.questionMatch[this.editingChoiceIndex].matches.length;
            i++
          ) {
            if (
              this.answer[itemIndex].index ==
              this.questionMatch[this.editingChoiceIndex].matches[i]
            ) {
              this.answer[itemIndex].hover = 0;
              itemIndex = i;
            }
          }
          this.removeItemFromChoice(this.editingChoiceIndex, itemIndex);
        }
      }
    },
    itemOnCheck(itemIndex) {
      return this.answer.hover[itemIndex] > 0 ? true : false;
    },
    clearChoicesHover() {
      for (var i = 0; i < this.questionMatch.length; i++) {
        this.questionMatch[i].hover = 0;
      }
    },
    clearItemsHover() {
      for (var i = 0; i < this.answer.length; i++) {
        this.answer[i].hover = 0;
      }
    },
    editOption(choice) {
      this.tempChoice = choice.text;
      this.editChoice = true;
      choice.boolean = true;
      this.bools = true;
      this.boolsAnswer = true;
    },
    canCelEditOption(choice) {
      console.log(this.questionMatch);
      let index = this.questionMatch.indexOf(choice);
      // if (choice.idLocal) {
      //   this.removeRow(choice);
      //   this.bools = false;
      //   this.boolsAnswer = false;
      //   this.editChoice = false;
      // } else {
      choice.text = this.tempChoice;
      choice.boolean = false;
      this.editChoice = false;
      this.bools = false;
      this.boolsAnswer = false;
      // }
    },
    removeRow: function (item) {
      let index = this.questionMatch.indexOf(item);
      if (this.questionMatch.length > 1) {
        this.questionMatch.splice(index, 1);
      } else {
        this.questionMatch.splice(index, 1);
        this.bools = false;
        this.editChoice = false;
      }
    },
    removeAnswer: function (item) {
      console.log(item);
      let index = this.answer.indexOf(item);
      if (this.answer.length > 1) {
        this.answer.splice(index, 1);
      } else {
        this.answer.splice(index, 1);
        this.boolsAnswer = false;
        this.editChoice = false;
      }
    },
    editOptionAnswer(item) {
      this.tempChoiceAnswer = item.text;
      this.editChoiceAnswer = true;
      item.boolean = true;
      this.bools = true;
      this.boolsAnswer = true;
    },
    canCelEditOptionAnswer(item) {
      let index = this.answer.indexOf(item);
      // if (item._id) {
      item.text = this.tempChoiceAnswer;
      item.boolean = false;
      this.editChoiceAnswer = false;
      this.boolsAnswer = false;
      this.bools = false;
      // } else {
      //   this.removeAnswer(item);
      //   this.editChoiceAnswer = false;
      //   this.boolsAnswer = false;
      //   this.bools = false;
      // }
    },
    addChoice() {
      this.questionMatch.push({
        text: this.addAnswer,
        matches: [],
        score: this.choiceScore,
        hover: 0,
        boolean: false,
        idLocal: true,
      });
      this.bools = false;
      this.addAnswer = '';
      this.choiceScore = null;
      this.$refs.form.resetValidation();
    },
    addItem() {
      this.answer.push({
        index: this.answer.length,
        text: this.addAnswerChoice,
        hover: 0,
        boolean: false,
      });
      this.boolsAnswer = false;
      this.addAnswerChoice = '';
      console.log(this.answer);
    },
    validationForm() {
      let bool = true;
      if (this.bools == true) {
        bool = false;
      }
      if (this.boolsAnswer == true) {
        bool = false;
      }
      if (this.oldQuestion && this.oldQuestion._id) {
        bool = true;
        this.valid = true;
      } else {
        this.questionMatch.forEach((question) => {
          if (question.text.length < 1) {
            bool = false;
          }
        });
        this.answer.forEach((item) => {
          if (item.text.length < 1) {
            bool = false;
          }
        });
        let sum = 0;
        this.questionMatch.forEach((question) => {
          sum += question.matches.length;
        });
        if (sum < 1) {
          bool = false;
        }
      }

      return this.valid && this.question != '' && bool;
    },
    async prepareQuestionObject() {
      let arrChoiceId = [];
      let arrQuestionMatch = [];
      let arrScore = [];
      let arrCorrect = [];

      this.answer = await this.answer.filter((item) => item.text.length > 0);

      for (var i = 0; i < this.answer.length; i++) {
        if (this.answer[i]._id) {
          let result = await updateChoice({
            id: this.answer[i]._id,
            text: this.answer[i].text,
          });
          await arrChoiceId.push(result._id);
        } else {
          let result = await insertChoice({ text: this.answer[i].text });
          await arrChoiceId.push(result._id);
        }
      }

      // this.questionMatch = await this.questionMatch.filter(question => question.text.length > 0);

      this.questionMatch.forEach(async (question) => {
        arrQuestionMatch.push(question.text);
        arrScore.push(parseFloat(question.score));

        let correctID = [];
        question.matches.forEach((i) => {
          this.answer.forEach(async (choice, index) => {
            if (i == choice.index) {
              correctID.push(arrChoiceId[index]);
            }
          });
        });
        arrCorrect.push({ correct: correctID });
      });

      let tmpQuestion = {
        idexam: this.examId,
        typeQuestion: 'matchsome',
        question: this.question,
        questionMatch: arrQuestionMatch,
        choices: arrChoiceId,
        correctMatch: arrCorrect,
        note: this.answer_description,
        randomChoice: this.randomChoices,
        arrayScore: arrScore,
        audio: this.audio_id,
        video: this.video_id,
      };
      return await tmpQuestion;
    },
    async validate(valueOption, choice) {
      console.log(valueOption, choice);
      let statusCode = false;
      let arrQuestionMatch = [];
      let arrScore = [];
      let arrCorrect = [];
      let arrChoiceId = [];
      let choiceCorrect = [];
      this.loading = true;
      if (this.$refs.form.validate()) {
        if (valueOption && choice == true) {
          if (valueOption._id) {
            let result = await updateChoice({
              id: valueOption._id,
              text: valueOption.text,
            });
            if (result.code && result.code != 200) {
              statusCode = result.code;
              this.dialogSaveFail = true;
            } else {
              statusCode = true;
              this.boolsAnswer = false;
              valueOption.boolean = false;
            }
          } else {
            let result = await insertChoice({ text: valueOption.text });
            if (result.code && result.code != 200) {
              statusCode = result.code;
              this.dialogSaveFail = true;
            } else {
              statusCode = true;
              this.boolsAnswer = false;
              valueOption.boolean = false;
              this.answer.pop();
              this.answer.push({
                _id: result._id,
                index: valueOption.index,
                text: result.text,
                hover: 0,
                boolean: false,
              });
            }
            console.log(this.answer);
          }
        } else {
          // no valueoption
          console.log('validate -> this.answer', this.answer);
          for (var i = 0; i < this.answer.length; i++) {
            if (this.answer[i].id) {
              let result = await updateChoice({
                id: this.answer[i].id,
                text: this.answer[i].text,
              });
              await arrChoiceId.push(result._id);
            } else {
              let result = await insertChoice({
                text: this.answer[i].text,
              });
              await arrChoiceId.push(result._id);
            }
          }
          // if (arrChoiceId) {
          //   arrChoiceId.forEach((value, index) => {
          //     this.answer_select.forEach((select) => {
          //       if (select === index) {
          //         choiceCorrect.push(value);
          //       }
          //     });
          //   });
          //   console.log('validate -> choiceCorrect', choiceCorrect);
          // }

          console.log('validate -> this.answer', this.answer);
          console.log('validate -> this.questionMatch', this.questionMatch);
          console.log('validate -> arrChoiceId', arrChoiceId);
          this.answer = await this.answer.filter(
            (item) => item.text.length > 0
          );
          // this.answer.forEach((choice) => {
          //   if (choice.id) {
          //     this.arrChoiceId.push(choice.id);
          //   }
          // });
          // console.log('validate -> this.arrChoiceId', this.arrChoiceId);

          this.questionMatch.forEach(async (question) => {
            arrQuestionMatch.push(question.text);
            arrScore.push(parseFloat(question.score));

            let correctID = [];
            question.matches.forEach((i) => {
              this.answer.forEach(async (choice, index) => {
                if (i == choice.index) {
                  correctID.push(arrChoiceId[index]);
                }
              });
            });
            arrCorrect.push({ correct: correctID });
          });
          console.log('validate -> arrCorrect', arrCorrect);

          let question = {
            idexam: this.examId,
            typeQuestion: 'matchsome',
            question: this.question,
            questionMatch: arrQuestionMatch,
            choices: arrChoiceId,
            correctMatch: arrCorrect,
            note: this.answer_description,
            randomChoice: this.randomChoices,
            arrayScore: arrScore,
            audio: this.audio_id,
            video: this.video_id,
          };

          if (this.articleId) {
            question = {
              ...question,
              articleQuestion: this.articleId,
            };
          }

          if (this.questionId) {
            let resultQuestion = await updateQuestion({
              id: this.questionId,
              ...this.oldQuestion,
              ...question,
            });
            if (resultQuestion.code && resultQuestion.code != 200) {
              this.dialogSaveFail = true;
            } else {
              this.loading = false;
              this.dialogSuccess = true;
              valueOption ? (valueOption.boolean = false) : '';
              this.addAnswerChoice = '';
              this.addAnswer = '';
              this.choiceScore = null;
              this.bools = false;
              // await getQuestionById({ id: this.questionId });
            }
            if (!valueOption) {
              this.closeDialog();
              this.clearDateValidation();
            }
            this.arrChoiceId = [];
          } else {
            if (!valueOption && !choice) {
              let resultQuestion = await insertQuestion(question);
              if (resultQuestion.code && resultQuestion.code != 200) {
                this.dialogSaveFail = true;
              } else {
                this.loading = false;
                this.dialogSuccess = true;
                valueOption ? (valueOption.boolean = false) : '';
                this.addAnswerChoice = '';
                this.addAnswer = '';
                this.choiceScore = null;
              }
              this.closeDialog();
              this.clearDateValidation();
            }
            valueOption ? (valueOption.boolean = false) : '';
            this.addAnswerChoice = '';
            this.addAnswer = '';
            this.bools = false;
            this.arrChoiceId = [];
          }
          this.arrChoiceId = [];
          this.editChoice = false;
          this.editChoiceAnswer = false;
        } // end
      } else {
        this.dialogSaveFail = true;
      }
    },
    async closeDialogQuestion() {
      let data = {
        question: this.question,
        question_score: this.question_score,
        answer_description: this.answer_description,
        setRandomChoice: this.setRandomChoice,
        audio_id: this.audio_id,
        video_id: this.video_id,
        answer: this.answer,
        questionMatch: this.questionMatch,
      };
      console.log('closeDialogQuestion -> data', data);
      if (JSON.stringify(this.oldQuestion) !== JSON.stringify(data)) {
        this.warnningToSaveDialog = true;
      } else {
        this.closeDialog();
        this.clearDateValidation();
      }
    },
    confirmCloseDialog() {
      this.warnningToSaveDialog = false;
      this.closeDialog();
      this.clearDateValidation();
    },
    clearDateValidation() {
      this.valid = true;
      this.dialog_1 = false;
      this.question = '';
      this.addAnswer = '';
      this.question_score = '';
      this.answer_description = '';
      this.setRandomChoice = false;
      this.answer = [];
      this.arrAnswer = [];
      this.itemChoice = [];
      this.selectTagLevel = null;
      this.scoreTag = null;
      this.bools = false;
      this.oldQuestion = {};
      this.answer_select = [];
      this.answer_correct = null;
      this.audio_id = null;
      this.video_id = null;
      this.addAnswerChoice = '';
      this.choiceScore = null;
      this.questionMatch = [];
      this.editChoice = false;
      this.editChoiceAnswer = false;
      this.boolsAnswer = false;

      this.$refs.form.resetValidation();
    },
    checkMinScore(choiceIndex) {
      if (this.questionMatch[choiceIndex].score < 0)
        this.questionMatch[choiceIndex].score = 0;
    },
    async closeMediaDialog() {
      this.mediaDialog = false;
      //this.registerTutoralert = true;
    },
    setVideo(data) {
      this.video_id = data;
      this.getPreview('video');
    },
    setAudio(data) {
      this.audio_id = data;
      this.getAudioPreview();
    },
    async getAudioPreview() {
      this.audio_url = await getPrivateFile(this.audio_id);
      if (this.audio_url) {
        this.isCheckComplete = true;
        this.audioPlaying = true;
      }
    },
    async getPreview(type) {
      let resultLink = await getPrivateVideo(
        type == 'audio' ? this.audio_id : this.video_id
      );
      if (resultLink.isCheckComplete !== undefined) {
        this.isCheckComplete = resultLink.isCheckComplete;
        if (resultLink.isCheckComplete) {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.url
          // (this.urlVideo = resultLink.url);
          // this.oldVideoUrl = resultLink.url
          this.audioPlaying = true;
        } else {
          type == 'audio'
            ? (this.audio_url =
                resultLink.urllocalhost +
                `?token=${localStorage.getItem(
                  'x-session-token'
                )}&server=${serverName}`)
            : this.playerOptions.sources[0].src =
                resultLink.urllocalhost

          this.audioPlaying = true;
        }

        //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
        // this.successUpload = true;
        // this.pendingUpload = false;
      }
    },
    deletemedia(type) {
      type == 'audio' ? (this.audio_id = null) : (this.video_id = null);
    },
    openMediaDialog(type) {
      type == 'audio' ? (this.mediaType = 'audio') : (this.mediaType = 'video');
      this.mediaDialog = true;
    },
  },
};
</script>

<style>
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.matching .editor .ql-container {
  min-height: 150px;
}
.matching .card-padding {
  padding: 40px;
}
.matching .choice {
  border-radius: 50px;
}
@media only screen and (max-width: 1024px) {
  .matching .card-padding {
    padding: 20px;
  }
  .matching .editor-style {
    margin-bottom: 160px;
  }
}
@media (max-width: 800px) {
  .resonsive-iframe {
    height: 500px;
  }
  .w-md-50 {
    width: 100%;
  }
}
.center-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.w-md-50 {
  width: 50%;
  margin: 0 auto;
}
</style>
<style scoped>
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.bg-editor {
  background-color: white !important;
}
</style>